/* istanbul ignore file */
import de from "./vf-footer-de";
import eg from "./vf-footer-eg";
import es from "./vf-footer-es";
import gb from "./vf-footer-gb";
import it from "./vf-footer-it";
import pt from "./vf-footer-pt";
import lw from "./vf-footer-lw";
import za from "./vf-footer-za";
import ro from "./vf-footer-ro";
import cz from "./vf-footer-cz";
import tr from "./vf-footer-tr";
import gr from "./vf-footer-gr";

import {
  OpcoDe,
  OpcoEs,
  OpcoGb,
  OpcoIt,
  OpcoEg,
  OpcoPt,
  OpcoLw,
  OpcoZa,
  OpcoRo,
  OpcoCz,
  OpcoTr,
  OpcoGr,
} from "types/Opco";

export type FooterConfigType = {
  "privacy-policy"?: string;
  "terms-and-conditions"?: string;
  "help-and-support"?: string;
  "cookie-preferences"?: string;
  imprint?: string;
  "terminate-contract"?: string;
};

const configs: Record<
  OpcoDe | OpcoEs | OpcoGb | OpcoIt | OpcoEg | OpcoPt | OpcoLw | OpcoZa | OpcoRo | OpcoCz | OpcoTr | OpcoGr,
  FooterConfigType
> = {
  de,
  es,
  gb,
  it,
  eg,
  pt,
  lw,
  za,
  ro,
  cz,
  tr,
  gr,
};

export default configs;
